import React, { Component } from 'react';
import StationSearchResult from './StationSearchResult';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class StationSearchResults extends Component {

  constructor(props) {
    super(props);
    this.onResultClick = this.onResultClick.bind(this);
  }

  componentDidMount() {
  }

  onResultClick(station_result) {
    return (e) => {
      this.props.selectResult(station_result)
    }
  }

  render() {
    if (!this.props.stations)
      return null;

    if(this.props.stations.length == 0) {
      return(
        <div className="station-results">
          <div className="group-label">{this.props.header}</div>
          <div className="notice">
            {i18n.t('stationSearchResults.no_matches')}
          </div>
        </div>);
    }

    return(
      <div className="station-results">
        <div className="group-label">{this.props.header}</div>
        <div className="results">
          {this.props.stations.slice((this.props.start || 0), (this.props.take || 50)).map((station) => {
            return(<StationSearchResult
              key={`${station.result_type}_${station.result_id}`}
              station={station}
              onResultClick={this.onResultClick}/>);
          })}
        </div>
      </div>
    );
  }
};

export default StationSearchResults;
